import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAmexCard = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#pet__clip0_15397_1555)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#006FCF",
				d: "M10.521 8.6645L10.9473 9.66186H12.4789L10.2485 4.62738L8.51564 4.61163L6.28937 9.63016H7.77355L8.21557 8.6645H10.5208H10.521ZM9.34466 5.88616L10.0434 7.52068H8.68541L9.34466 5.88616Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#006FCF",
				d: "M15.7158 7.73034L14.6264 4.61163H13.6789L13.6671 4.62738H12.4789V9.63016H13.8369V6.07741L15.1159 9.66186H16.3157L17.642 6.11545V9.66186H19V4.62738H16.8999L15.7158 7.73034Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#006FCF",
				d: "M17.1685 10.4218L15.7396 11.9616L14.3106 10.4218H12.4946V10.3901H9.57374H9.27367H8.21576V15.4243H9.27367H9.57374H12.4946V14.3004H9.57374V13.4851H12.4946V12.3611H9.57374V11.5141H12.4946V10.4386L14.8396 12.9316L12.5264 15.4243H14.2948L15.7396 13.8884L17.1843 15.4243H18.9526L16.6394 12.9316L19 10.4218H17.1685Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#006FCF",
				d: "M1 1V19H18.9525V16.0576H16.758L15.7078 14.9099L14.5947 16.1447H7.43418V10.3821H5.10523L7.98686 3.89391H10.7421L11.7131 6.076V3.89391H15.1237L15.7473 5.56157L16.3395 3.89391H19V1H1Z"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "pet__clip0_15397_1555",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgAmexCard);
export default ForwardRef;
